import React from "react";
import { StyleSheet, View } from "react-native";
import { Button } from "src/components";
import { colors } from "src/assets";

export type NavigationBarProps = {
  isAuth?: boolean;
  isOwn?: boolean;
  isFavorite?: boolean;
  onBack?: () => void;
  onFavorite?: () => void;
  onMore?: () => void;
  onEdit?: () => void;
};

export const NavigationBar: React.FC<NavigationBarProps> = ({
  isAuth,
  isOwn,
  isFavorite,
  onBack,
  onFavorite,
  onMore,
  onEdit,
}) => {
  return (
    <View style={styles.toolbar}>
      <Button
        variant={"icon"}
        icon={"chevron"}
        iconSize={14}
        onPress={onBack}
        containerStyle={styles.btnBack}
      />
      <View style={styles.toolbarRightItems}>
        {isOwn && isAuth ? (
          <Button
            variant={"icon"}
            icon={"edit"}
            iconSize={22}
            iconColor={colors.chokuRed}
            iconStyle={styles.btnEdit}
            onPress={onEdit}
            containerStyle={styles.btnCircle}
          />
        ) : isAuth ? (
          <React.Fragment>
            <Button
              variant={"icon"}
              icon={isFavorite ? "heart-filled" : "heart"}
              iconSize={18}
              iconColor={colors.chokuRed}
              onPress={onFavorite}
              containerStyle={styles.btnCircle}
            />
            <Button
              variant={"icon"}
              icon={"more-circle"}
              iconSize={18}
              iconColor={colors.chokuRed}
              onPress={onMore}
              containerStyle={styles.btnCircle}
            />
          </React.Fragment>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  toolbar: {
    zIndex: 999,
    position: "absolute",
    left: 0,
    top: 8,
    right: 0,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  toolbarRightItems: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  btnBack: {
    backgroundColor: colors.chokuRed,
    height: 32,
    width: 32,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    paddingRight: 3,
  },
  btnCircle: {
    backgroundColor: colors.white,
    height: 32,
    width: 32,
    borderRadius: 16,
    marginRight: 8,
  },
  btnEdit: {
    paddingLeft: 4,
    paddingTop: 2,
  },
});
